module.exports = __webpack_public_path__ + "media/images/gallery/9s-f6927f58a9489ed6d5c17766b748533d.jpg";